import { useWindowDimensions } from "@hooks/useWindowDimensions";

function useIsSmallDisplay(): boolean {
  const dimensions = useWindowDimensions();

  return dimensions.width < 1400;
}

export default useIsSmallDisplay;
